import React, { useState, useEffect, useRef } from 'react';
import ErpTemplate from '../../../components/ErpTemplate';
import { FaPlus, FaSearch, FaPen, FaThumbsUp } from 'react-icons/fa';
import { ImCancelCircle } from 'react-icons/im';
import { Link, useLocation } from 'react-router-dom';
import api from '../../../services/api';
import Alert from '../../../components/Alert';
import { FinCheck } from '../../../components/FinField';
import { toast } from 'react-toastify';
import { TIPOS_PARTICIPANTE_PALESTRANTE } from '../../../util/util';
import '../../../css/financeiro-parcela-pagar.css';

export default function PainelEventoPalestrante({ match }) {
    let { state } = useLocation();
    const id = match.params.id;
    const token = localStorage.getItem('token');
    const perfil = localStorage.getItem("perfil");
    const [filtro, setFiltro] = useState({});
    const [buscando, setBuscando] = useState(false);
    const [eventoParticipantes, setEventoParticipantes] = useState([]);
    const [evento, setEvento] = useState({});
    const [selectedIds, setSelectedIds] = useState(new Set());
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);
    const controllerRef = useRef(null);
    const operador = state?.operador ?? null;

    const buscar = () => {
        if (controllerRef.current) controllerRef.current.abort();
        controllerRef.current = new AbortController();
        setBuscando(true);

        api({
            method: 'get',
            action: '/evento',
            token: token,
            params: { id: id },
            signal: controllerRef.current.signal
        }).then(response => {
            setEvento(response.data.data[0]);
            setBuscando(false);
        }).catch(err => {
            if (err.code === "ERR_CANCELED" || err.name === "CanceledError") return;
            setBuscando(false);
        });

        api({
            method: 'get',
            action: '/participante',
            token: token,
            params: {
                ...filtro,
                evento: id,
                tipoCadastro: ["participante", "palestrante"],
                tipoparticipante: TIPOS_PARTICIPANTE_PALESTRANTE, //3 - Palestrante Hcp | 8 - Palestrante Não Hcp
            },
            signal: controllerRef.current.signal
        }).then(response => {
            setEventoParticipantes(response.data.data);
            setSelectedIds(new Set());
            setPage(1);
        }).catch(err => {
            if (err.code === "ERR_CANCELED" || err.name === "CanceledError") return;
        });
    };

    useEffect(() => {
        buscar();
        return () => { if (controllerRef.current) controllerRef.current.abort(); };
    },
        // eslint-disable-next-line
        []);

    const excluirSelecionados = () => {
        const ids = [...selectedIds].join(",");
        Alert({
            icon: "error",
            confirmButton: "Sair",
            denyButton: <><FaThumbsUp size={20} /> Excluir</>,
            title: "Excluir",
            callBack: (result) => {
                if (result.isDenied) {
                    api({
                        method: 'delete',
                        action: '/participantes',
                        token: token,
                        data: { idParticipantes: ids }
                    }).then(() => {
                        buscar();
                    }).catch(() => {});
                }
            }
        });
    };

    const total = eventoParticipantes.length;
    const totalPaginas = Math.max(1, Math.ceil(total / pageSize));
    const paginados = eventoParticipantes.slice((page - 1) * pageSize, page * pageSize);
    const podeExcluir = ['admin', 'diretor', 'gerenteprojeto', 'rsvp'].includes(perfil);
    const mostrarCheckbox = !['listarsvp'].includes(perfil);
    const colSpan = mostrarCheckbox ? 4 : 3;

    const toggleSelect = (rowId) => {
        setSelectedIds(prev => {
            const next = new Set(prev);
            if (next.has(rowId)) next.delete(rowId);
            else next.add(rowId);
            return next;
        });
    };

    const toggleAll = () => {
        if (paginados.length > 0 && selectedIds.size === paginados.length) {
            setSelectedIds(new Set());
        } else {
            setSelectedIds(new Set(paginados.map(r => r.id)));
        }
    };

    // Marca se o palestrante aparece no select de Palestrante do cadastro de pergunta (portal do cliente).
    // Salva na hora; se o PUT falhar, a marcação volta.
    const alternarPergunta = (row) => {
        const recebePergunta = !row.recebePergunta;
        const marcar = (valor) => setEventoParticipantes(prev => prev.map(p => p.id === row.id ? { ...p, recebePergunta: valor } : p));
        marcar(recebePergunta);
        api({
            method: 'put',
            action: '/participante/' + row.id,
            token: token,
            data: { recebePergunta },
        }).catch(error => {
            marcar(!recebePergunta);
            toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
        });
    };

    return (
        <ErpTemplate sidebar={['listarsvp'].includes(perfil) ? false : true}>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div>
                        <h1 className="fin-pp__title">Palestrantes</h1>
                        {evento.nome && <p className="fin-pp__subtitle">{evento.nome}</p>}
                    </div>
                    <div className="fin-pp__actions">
                        <Link
                            to={{ pathname: "/cadastroEventoPalestrante", state: { evento: id } }}
                            className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--pill"
                        >
                            <FaPlus size={14} /> Novo Palestrante
                        </Link>
                    </div>
                </div>

                <form
                    className="fin-pp__card fin-pp__search"
                    style={{ marginBottom: 16, padding: '12px 16px' }}
                    onSubmit={(e) => { buscar(); e.preventDefault(); }}
                >
                    <div className="fin-pp__search-field">
                        <FaSearch className="fin-pp__search-ic" size={16} />
                        <input
                            autoFocus
                            className="fin-pp__input"
                            type="text"
                            placeholder="Buscar pelo nome do palestrante"
                            onChange={e => setFiltro({ ...filtro, nome: e.target.value })}
                        />
                    </div>
                    <button type="submit" className="fin-pp__btn fin-pp__btn--primary" disabled={buscando}>
                        {buscando ? 'Buscando...' : 'Buscar'}
                    </button>
                </form>

                {podeExcluir && selectedIds.size > 0 && (
                    <div style={{ marginBottom: 8, display: 'flex', justifyContent: 'flex-end' }}>
                        <button
                            type="button"
                            className="fin-pp__btn fin-pp__btn--danger fin-pp__btn--sm"
                            onClick={excluirSelecionados}
                        >
                            <ImCancelCircle size={14} /> Excluir ({selectedIds.size})
                        </button>
                    </div>
                )}

                <div className="fin-pp__card" style={{ overflow: 'hidden' }}>
                    <div className="fin-pp__tblwrap">
                        <table className="fin-pp__tbl" style={{ tableLayout: 'auto' }}>
                            <thead>
                                <tr>
                                    {mostrarCheckbox && (
                                        <th style={{ width: 40 }}>
                                            <input
                                                type="checkbox"
                                                checked={paginados.length > 0 && selectedIds.size === paginados.length}
                                                onChange={toggleAll}
                                            />
                                        </th>
                                    )}
                                    <th style={{ width: 60 }}></th>
                                    <th>Nome</th>
                                    <th style={{ width: 140 }}>Aparece no Q&A</th>
                                </tr>
                            </thead>
                            <tbody>
                                {buscando ? (
                                    <tr><td colSpan={colSpan} className="fin-pp__empty"><span className="fin-pp__loading"><span className="fin-pp__spin"></span>Buscando...</span></td></tr>
                                ) : paginados.length === 0 ? (
                                    <tr><td colSpan={colSpan} className="fin-pp__empty">
                                        {['listarsvp'].includes(perfil) ? "Busque para listar" : "Nenhum registro"}
                                    </td></tr>
                                ) : paginados.map(row => (
                                    <tr key={row.id}>
                                        {mostrarCheckbox && (
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    checked={selectedIds.has(row.id)}
                                                    onChange={() => toggleSelect(row.id)}
                                                />
                                            </td>
                                        )}
                                        <td>
                                            <Link
                                                to={{ pathname: "/cadastroEventoPalestrante/" + row.id, state: { evento: id } }}
                                                className="fin-pp__rowbtn"
                                            >
                                                <FaPen size={14} />
                                            </Link>
                                        </td>
                                        <td className="fin-pp__cell-strong">
                                            {['listarsvp'].includes(perfil)
                                                ? row.nome
                                                : <>{row.codigo}-{row.nome} - {row.cnpj}{row.cpf}</>
                                            }
                                        </td>
                                        <td>
                                            <FinCheck
                                                id={'qa-' + row.id}
                                                checked={!!row.recebePergunta}
                                                disabled={!mostrarCheckbox}
                                                onChange={() => alternarPergunta(row)}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="fin-pp__pagination">
                        <div className="fin-pp__pagination-info">{total} registros</div>
                        <div className="fin-pp__pagination-ctrls">
                            <select
                                className="fin-pp__select"
                                style={{ height: 34 }}
                                value={pageSize}
                                onChange={e => { setPageSize(Number(e.target.value)); setPage(1); }}
                            >
                                <option value={15}>15 / pág</option>
                                <option value={30}>30 / pág</option>
                                <option value={50}>50 / pág</option>
                            </select>
                            <button className="fin-pp__btn fin-pp__btn--sm" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>Anterior</button>
                            <span className="fin-pp__pagination-info">{page} / {totalPaginas}</span>
                            <button className="fin-pp__btn fin-pp__btn--sm" disabled={page >= totalPaginas} onClick={() => setPage(p => p + 1)}>Próxima</button>
                        </div>
                    </div>
                </div>
            </div>
        </ErpTemplate>
    );
}
